import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
  Divider,
  IconButton,
  Box,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IDepartmentListDTO } from "../../interfaces/UserManagement";
import { activateDeactivateDepartment } from "../../services/UserManagement";

interface DepartmentConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  department: IDepartmentListDTO | null;
}

const DepartmentConfirmDialog =({open,onClose,onSave,department,}: DepartmentConfirmDialogProps) =>{
  const [msg, setMsg] = useState("");
  const [openError, setOpenError] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (!department) return;
  
    setLoading(true);
    try {
      const res = await activateDeactivateDepartment(department.departmentId);
      if (res && res.status === "success") {
        setOpenSuccess(true);
        setMsg("Successfully changed the Status");
        onSave();
        onClose();
      } else {
        setOpenError(true);
        setMsg("Failed to update  status.");
      }
    } catch (error) {
      setOpenError(true);
      setMsg("Unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };
  
  const handleClose = () => {
    if (openSuccess) {
      setOpenSuccess(false);
    } else if (openError) {
      setOpenError(false);
    }
    setMsg("");
  };
  return (
    <>
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: "16px", border: "2px solid #D6E5FF", boxShadow: "20px 20px 20px 0 rgba(0, 0, 0, 0.08)" } }} slotProps={{ backdrop: { sx: { backdropFilter: "blur(4px)" } } }}>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", pb: 1, pr: 6 }}>
        <Box>
          <Typography sx={{ fontSize: "20px", fontWeight: 700, color: "text.primary" }}>Are you sure want to {department?.status === "Active" ? "Deactivate" : "Activate"} the Department ?</Typography>
          <Typography sx={{ fontSize: "16px", fontWeight: 400, color: "#757A89", mt: 0.5 }}>
            {department?.status === "Inactive" 
              ? "The Department will be Activated & All users in That Department regain there Access, you can Inactivate it later."
              : "The Department will be Inactive & All users in That Department loss there Access, you can Activate it later."}
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small" sx={{ position: "absolute", right: 16, top: 16 }}><CloseIcon /></IconButton>
      </DialogTitle>
      <Divider />
      <DialogActions sx={{ p: 2, justifyContent: "space-between" }}>
        <Button onClick={onClose} variant="outlined" sx={{ borderRadius: "28px", border: "1px solid #FE0909", bgcolor: "#FFF", color: "#FE0909", padding: "8px 16px", textTransform: "none", minWidth: "120px", "&:hover": { border: "1px solid #FE0909", bgcolor: "#FFF" } }}>No</Button>
        <Button onClick={handleConfirm} disabled={loading} variant="contained" sx={{ borderRadius: "28px", border: "1px solid #005EFF", bgcolor: "#005EFF", color: "#fff", padding: "8px 16px", textTransform: "none", minWidth: "120px", "&:hover": { bgcolor: "#005EFF" } }}>{loading ? <CircularProgress size={22} sx={{ color: "#fff" }} /> : "Yes"}</Button>
      </DialogActions>
    </Dialog>
     {/** Snackbar alerts */}
     <Snackbar
     anchorOrigin={{ vertical: "top", horizontal: "right" }}
     open={openError}
     autoHideDuration={5000}
     onClose={handleClose}
   >
     <Alert severity="error" variant="filled" sx={{ width: "100%" }}>
       {msg}
     </Alert>
   </Snackbar>

   <Snackbar
     anchorOrigin={{ vertical: "top", horizontal: "right" }}
     open={openSuccess}
     autoHideDuration={5000}
     onClose={handleClose}
   >
     <Alert severity="success" variant="filled" sx={{ width: "100%" }}>
       {msg}
     </Alert>
   </Snackbar>
   </>
  );
};
export default DepartmentConfirmDialog;
